
// TEACHERs
export const GET_TEACHERS = "/teachers";
export const ADD_NEW_TEACHER = "/teachers";
export const UPDATE_TEACHER = "/teachers";
export const DELETE_TEACHER = "/teachers";


